import { OrderProcessStructure } from '@app/core/services/api/API.service';
import {
    applyMandatoryManagementAndAdminNotificationsForPositionOne,
    buildOcFlowWithAuthorizationSkeleton,
    buildOrderProcessesFromSkeleton,
    buildSubprocessStructuresFromSkeleton,
    COUPA_FLOW_SKELETON,
    HIBRIDO_COUPA_FIRST_PROCESS_SUB_SKELETON,
    OC_FLOW_SKELETON,
    TDC_TRANSFER_FLOW_SKELETON
} from './build-preconfigured-premium-flows';

export {
    applyMandatoryManagementAndAdminNotificationsForPositionOne,
    buildDefaultPremiumProcessCards,
    buildDefaultMessagesForPremiumAction,
    buildDefaultNotificationsForPremiumAction,
    buildOrderProcessesFromSkeleton,
    buildSubprocessStructuresFromSkeleton,
    COUPA_FLOW_SKELETON,
    buildOcFlowWithAuthorizationSkeleton,
    HIBRIDO_COUPA_FIRST_PROCESS_SUB_SKELETON,
    OC_FLOW_SKELETON,
    TDC_TRANSFER_FIRST_PROCESS_SUB_SKELETON,
    TDC_TRANSFER_FLOW_SKELETON,
    PreconfiguredProcessSkeleton,
    PreconfiguredProcessSubSkeleton
} from './build-preconfigured-premium-flows';

export {
    PRECONFIGURED_DEFAULT_PROCESS_DURATION_EMPTY,
    PRECONFIGURED_DEFAULT_PROCESS_DURATION_INDEFINIDO,
    PRECONFIGURED_DEFAULT_PROCESS_DURATION_INDEFINIDO_LABEL,
    preconfiguredDefaultProcessResponsibleId,
    preconfiguredSubSkeleton
} from './preconfigured-premium-flow-defaults';

export const PRECONFIGURED_COUPA_PROCESSES: OrderProcessStructure[] = buildOrderProcessesFromSkeleton(
    COUPA_FLOW_SKELETON
);

export const PRECONFIGURED_OC_PROCESSES: OrderProcessStructure[] = buildOrderProcessesFromSkeleton(
    OC_FLOW_SKELETON
);

const OC_FLOW_WITH_AUTHORIZATION_SKELETON_SINGLE = buildOcFlowWithAuthorizationSkeleton(
    false
);
const OC_FLOW_WITH_AUTHORIZATION_SKELETON_DOUBLE = buildOcFlowWithAuthorizationSkeleton(
    true
);

/** OC con autorización en «Cotización» antes de OC (11 → 30). */
export const PRECONFIGURED_OC_WITH_AUTHORIZATION_PROCESSES_SINGLE: OrderProcessStructure[] = buildOrderProcessesFromSkeleton(
    OC_FLOW_WITH_AUTHORIZATION_SKELETON_SINGLE
);

/** OC con doble autorización en «Cotización» antes de OC (11 → 24 → 30). */
export const PRECONFIGURED_OC_WITH_AUTHORIZATION_PROCESSES_DOUBLE: OrderProcessStructure[] = buildOrderProcessesFromSkeleton(
    OC_FLOW_WITH_AUTHORIZATION_SKELETON_DOUBLE
);

export const PRECONFIGURED_TDC_TRANSFER_PROCESSES: OrderProcessStructure[] = buildOrderProcessesFromSkeleton(
    TDC_TRANSFER_FLOW_SKELETON
);

/**
 * Flujo híbrido Coupa: clona TDC (carrito transferencia o tarjeta) y reemplaza el
 * primer proceso por la lista con Coupa (posiciones duplicadas). Del proceso 2
 * en adelante coincide con `tdc_transfer`.
 */
export function buildHibridoCoupaProcesses(): OrderProcessStructure[] {
    const tdc = structuredClone(
        buildOrderProcessesFromSkeleton(TDC_TRANSFER_FLOW_SKELETON)
    ) as OrderProcessStructure[];
    const firstTdc = tdc[0];
    if (!firstTdc?.id) {
        return tdc;
    }
    firstTdc.subprocesses = applyMandatoryManagementAndAdminNotificationsForPositionOne(
        buildSubprocessStructuresFromSkeleton(
            firstTdc.id,
            HIBRIDO_COUPA_FIRST_PROCESS_SUB_SKELETON
        )
    );
    firstTdc.descripcion =
        'Transferencia (comprobante y validación), checkout a Coupa y a Clip, carga de OC Coupa y validación del pago con Clip.';
    return tdc;
}
